<template>
  <t-layout>
    <t-aside>
      <Header />
    </t-aside>

    <t-layout>
      <t-content style="min-height:100vh">
        <div style="padding:20px">

          <div class="flex space-between">
            <span class="c-main fs-26 fw-600">用户列表</span>
            <t-button @click="openAddDialog">添加用户</t-button>
          </div>

          <div class="mt-20">
            <t-table
                row-key="id"
                :data="listData"
                :columns="columns"
                :stripe="true"
                bordered
            >

              <template #operate="{ row }">

                <t-button
                    size="small"
                    theme="warning"
                    @click="openResetDialog(row)"
                >
                  重置密码
                </t-button>

              </template>

            </t-table>

            <div style="margin-top:16px;display:flex;justify-content:flex-end">

              <SimplePage
                  :pagination="pagination"
                  @change="rehandlePageChange"
                  storage-key="userList"
              />

            </div>
          </div>

          <!-- 添加用户 -->
          <AddUserDialog
              v-model:visible="addVisible"
              @success="getUserList"
          />

          <!-- 重置密码 -->
          <ResetPasswordDialog
              v-model:visible="resetVisible"
              :user="currentUser"
          />

        </div>
      </t-content>
    </t-layout>
  </t-layout>
</template>
<script setup>

import { ref,onMounted } from 'vue'
import Header from '@/components/header.vue'
import SimplePage from '@/components/SimplePage.vue'

import AddUserDialog from '@/views/user/AddUserDialog.vue'
import ResetPasswordDialog from '@/views/user/ResetPasswordDialog.vue'

import { userListApi } from '@/api/user'

const listData = ref([])

const addVisible = ref(false)
const resetVisible = ref(false)

const currentUser = ref({})

const columns = [
  { colKey:'name',title:'用户名称'},
  { colKey:'phone',title:'手机号'},
  { colKey:'operate',title:'操作',width:160}
]

const pagination = ref({
  current:1,
  pageSize:20,
  total:0
})

onMounted(()=>{
  getUserList()
})

const getUserList = ()=>{

  userListApi({
    page:pagination.value.current,
    page_size:pagination.value.pageSize
  }).then(res=>{

    if (res.data.code == 200) {
      let data = res.data.data

      listData.value = data.list

      pagination.value.total = data.total
    }

  })
}

const rehandlePageChange = (pageInfo)=>{
  pagination.value.current=pageInfo.current
  pagination.value.pageSize=pageInfo.pageSize
  getUserList()
}

const openAddDialog=()=>{
  addVisible.value=true
}

const openResetDialog=(row)=>{
  currentUser.value=row
  resetVisible.value=true
}

</script>